class BeforeAfterPage extends HTMLElement {
    connectedCallback() {
      this.selectedOption = this.querySelector('.selected-option');
      this.optionsList = this.querySelector('.mobile-drop-down');
      this.optionItemsMo = this.querySelectorAll('.mobile-drop-down li');
      
      this.optionItems = this.querySelectorAll('.product_name');
      this.optionItems.forEach(item => {
        item.addEventListener('click', this.onOptionItemClick.bind(this, item));
      });
      this.selectedOption.addEventListener('click', this.openDropdown.bind(this));
      this.optionItemsMo.forEach(item => {
        item.addEventListener('click', this.customseDropdownChange.bind(this, item));
      });
          
  }
  customseDropdownChange(item) {
    this.optionItemsMo.forEach(li => {
    li.classList.remove('active');
    });
    item.classList.add('active');

    this.selectedOption.textContent = item.textContent;
    const dataValue = item.dataset.value;
    console.log(dataValue, 'dataValue')
    if(dataValue == "all") {
      document.querySelectorAll(`.blog_wrapper`).forEach((blog_item) => {
        blog_item.classList.remove('hidden');
      });
    } else {
    document.querySelectorAll(`.blog_wrapper`).forEach((blog_item) => {
        blog_item.classList.add('hidden');
    });
  
    document.querySelectorAll(`.blog_wrapper[data-content="${dataValue}"]`).forEach((blog_item) => {
        blog_item.classList.remove('hidden');
    });
      
    }
     this.optionsList.style.display = this.optionsList.style.display === 'block' ? 'none' : 'block';
    
  }
  openDropdown() {
     this.optionsList.style.display = this.optionsList.style.display === 'block' ? 'none' : 'block';
  }
  onOptionItemClick(item) {
    this.optionItems.forEach(li => {
        li.classList.remove('active');
    });
    item.classList.add('active');

    const dataValue = item.dataset.value;
    console.log(dataValue, 'dataValue')
    if(dataValue == "all") {
      document.querySelectorAll(`.blog_wrapper`).forEach((blog_item) => {
        blog_item.classList.remove('hidden');
      });
    } else {
    document.querySelectorAll(`.blog_wrapper`).forEach((blog_item) => {
        blog_item.classList.add('hidden');
    });

    document.querySelectorAll(`.blog_wrapper[data-content="${dataValue}"]`).forEach((blog_item) => {
        blog_item.classList.remove('hidden');
    });
      
    }

 
    
  }

   
}
customElements.define("before-after-page", BeforeAfterPage);